/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { LiaDownloadSolid } from "react-icons/lia";
import { makeStyles } from "@material-ui/core/styles";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";
import { RiDownloadLine, RiCloseFill } from "react-icons/ri";

import * as Styles from "./style";

interface Props {
  title: string;
  data?: any;
}

const useStyles = makeStyles((theme: any) => ({
  modal: {
    border: "none",
    boxShadow: "none",
  },
  modalContainer: {},
  buttonArrow: {
    backgroundColor: "#eaefff",
    "&:hover": {
      backgroundColor: "#eaefff", // Cor de fundo ao passar o mouse
    },
    "&:disabled": {
      backgroundColor: "rgba(234, 239, 255, 0.5)", // Ajuste a opacidade conforme necessário
    },
  },
  aboveButton: {
    height: 20,
    width: 20,
    backgroundColor: "#eaefff",
    "&:hover": {
      backgroundColor: "#eaefff", // Cor de fundo ao passar o mouse
    },
  },
}));

const Carousel = (props: Props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [imageindex, setImageIndex] = useState<number | null>(null);
  const [urlFoto, setUrlFoto] = useState<string>(
    "https://fastly.picsum.photos/id/320/536/354.jpg?hmac=zcBiVT7i6DxsumWqwd7Vr_02wXb3mJCz9wSjIqdEIJk"
  );

  function handleOpenModal(assets: string, idx: number) {
    setUrlFoto(assets);
    setImageIndex(idx);
    setOpen(true);
  }

  function handleNext() {
    if (imageindex !== null) {
      setUrlFoto(props?.data[imageindex + 1].url);
      setImageIndex(imageindex + 1);
    }
  }

  function handleBack() {
    if (imageindex !== null) {
      setUrlFoto(props?.data[imageindex - 1].url);
      setImageIndex(imageindex - 1);
    }
  }

  const downloadImage = async (url: string) => {
    try {
      const response = await fetch(url, {
        mode: "no-cors",
      });
      const blob = await response.blob();
      const urlBlob = window.URL.createObjectURL(blob);

      // Extrair o nome do arquivo da URL
      const filenameWithExtension =
        url.split("/").pop()?.split("?")[0] || "downloaded_image";
      const filename = filenameWithExtension.split(".")[0];

      // Obter a data e hora atuais
      const now = new Date();
      const dateStr = now.toISOString().split("T")[0];
      const timeStr = now.toTimeString().split(" ")[0].replace(/:/g, "-");

      // Concatenar o nome do arquivo com a data e hora, garantindo a extensão .webp
      const fullFilename = `${filename}-${dateStr}-${timeStr}.webp`;

      const a = document.createElement("a");
      a.href = urlBlob;
      a.download = fullFilename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

  return (
    <>
      <Styles.ContentContainer>
        <Styles.SectionContent>
          <Styles.Shortcuts>
            <Styles.ShortcutsTitle>{props.title}</Styles.ShortcutsTitle>
            <Swiper
              breakpoints={{
                768: {
                  slidesPerView: 4,
                },
                1024: {
                  slidesPerView: 6,
                },
                1350: {
                  slidesPerView: 8,
                },
                1600: {
                  slidesPerView: 10,
                },
              }}
              spaceBetween={8}
              pagination={{
                clickable: true,
              }}
              modules={[Pagination]}
            >
              {props?.data?.map((item: any, index: number) => (
                <SwiperSlide key={item?.url}>
                  <a
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    href={item?.url}
                    rel="noreferrer"
                  >
                    <Styles.DownloadButton>
                      <LiaDownloadSolid />
                    </Styles.DownloadButton>
                  </a>
                  <Styles.ShortcutCard
                    onClick={() => handleOpenModal(item?.url, index)}
                    src={item?.url}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Styles.Shortcuts>
        </Styles.SectionContent>
      </Styles.ContentContainer>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        unselectable="off"
        className={classes.modal}
      >
        <Styles.ModalContainer>
          <Styles.ButtonArrow
            className={classes.buttonArrow}
            onClick={() => handleBack()}
            disabled={imageindex === 0}
          >
            <FaChevronLeft size={18} />
          </Styles.ButtonArrow>
          <Styles.ContainerImage>
            <Styles.RowReverse>
              <Styles.ButtonSmall
                className={classes.aboveButton}
                onClick={() => setOpen(false)}
              >
                <RiCloseFill size={18} color="#2D5BFF" />
              </Styles.ButtonSmall>
              <Styles.SpaceX space={8} />
              <Styles.ButtonSmall
                className={classes.aboveButton}
                onClick={() => window.open(urlFoto, "_blank")}
              >
                <RiDownloadLine color="#2D5BFF" size={18} />
              </Styles.ButtonSmall>
            </Styles.RowReverse>
            <Styles.ModalImage src={urlFoto} />
          </Styles.ContainerImage>

          <Styles.ButtonArrow
            className={classes.buttonArrow}
            onClick={() => handleNext()}
            disabled={imageindex === props?.data?.length - 1}
          >
            <FaChevronRight size={18} />
          </Styles.ButtonArrow>
        </Styles.ModalContainer>
      </Modal>
    </>
  );
};

export default Carousel;
